import Swal from "sweetalert2";
import Cookies from 'js-cookie';
import { toast } from 'react-toastify';

export const login = (data) => {
    const { token, user_id, email, company_name, fullname, rememberMe } = data;
    // console.log("login", data)
    const expirationDate = rememberMe ? new Date(new Date().getTime() + 30 * 24 * 60 * 60 * 1000) : null;
    const cookieOptions = {
        path: '/',
        // secure: true,
        sameSite: 'Lax',
        ...(expirationDate && { expires: expirationDate }), // Pass a Date object if rememberMe is true
    };

    // ✅ Set user info
    Cookies.set('email', email, cookieOptions);
    Cookies.set('user_id', user_id, cookieOptions);
    Cookies.set('company_name', company_name, cookieOptions);
    Cookies.set('fullname', fullname, cookieOptions);

    // ✅ Set tokens
    if (token) {
        Cookies.set('access_token', token, cookieOptions);
    }
    if (token?.refresh) {
        Cookies.set('refresh_token', token.refresh, cookieOptions);
    }
};

export const logout = () => {
    //change this accordingly
    Cookies.remove('access_token');
    Cookies.remove('email');
    Cookies.remove('user_id');
    Cookies.remove('fullname');
    Cookies.remove('company_name');

    return true;
}

export const isLogin = () => {
    //return true;
    if (Cookies.get('admin_user_token')) { //change this accordingly
        return true;
    }

}

export const getOnlyToken = () => {
    const token = Cookies.get('admin_user_token');
    return token;
}

export const setCookie = (name, value, days = 7) => {
    const expires = new Date(Date.now() + days * 864e5).toUTCString();
    document.cookie = name + '=' + encodeURIComponent(value) + '; expires=' + expires + '; path=/';
};

export const getCookie = (name) => {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return decodeURIComponent(parts.pop().split(';').shift());
    return '';
};
// Sweetalert functions
export const triggerAlert = (icon, title, message) => {
    return Swal.fire({
        icon: icon,
        title: title,
        text: message,
        timer: 5000,
    })
}
export const simpleAlert = (text) => {
    return Swal.fire({
        text: text,
        timer: 3000,
    })
}



export const ConfirmationAlert = async (title, buttonText, buttonFunc) => {
    // Detect current theme
    const currentTheme = document.documentElement.getAttribute('data-bs-theme') || 'light';
    const isDarkTheme = currentTheme === 'dark';

    const result = await Swal.fire({
        title: 'Are you sure?',
        text: title,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#198754',
        cancelButtonColor: '#6c757d',
        allowOutsideClick: false,
        allowEscapeKey: false,
        allowEnterKey: false,
        confirmButtonText: buttonText,
        timer: null,//3000,
        background: isDarkTheme ? '#2a2a2a' : '#ffffff',
        color: isDarkTheme ? '#ffffff' : '#333333',
        backdrop: isDarkTheme ? 'rgba(0, 0, 0, 0.8)' : 'rgba(0, 0, 0, 0.4)',
        customClass: {
            popup: isDarkTheme ? 'swal2-dark-theme' : 'swal2-light-theme',
            title: isDarkTheme ? 'swal2-title-dark' : 'swal2-title-light',
            content: isDarkTheme ? 'swal2-content-dark' : 'swal2-content-light',
            confirmButton: isDarkTheme ? 'swal2-confirm-dark' : 'swal2-confirm-light',
            cancelButton: isDarkTheme ? 'swal2-cancel-dark' : 'swal2-cancel-light'
        }
    });
    if (result.isConfirmed) {
        buttonFunc();
    }
}

// Common config for all toasts
const toastConfig = {
    position: 'top-right',
    autoClose: 3000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    theme: 'auto', // auto-switches between light/dark
};

export const showSuccessToast = (message) => {
    toast.success(message, toastConfig);
};

export const showErrorToast = (message) => {
    toast.error(message, toastConfig);
};

export const showWarningToast = (message) => {
    toast.warning(message, toastConfig);
};

export const showInfoToast = (message) => {
    toast.info(message, toastConfig);
};

//converting files to base64

export function getBase64(file) {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();

        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = (error) => reject(error);
    });
}

export const AlertWithButton = async (title, htmlCode, buttonText, buttonFunc) => {
    const result = await Swal.fire({
        title: title,
        html: htmlCode,
        confirmButtonText: buttonText,
    });
    if (result.isConfirmed) {
        buttonFunc();
    }
}

export const formatDateTime = (dateTimeInput, format) => {
    let date, time;

    // Handle different formats of dateTimeInput
    if (typeof dateTimeInput === 'string') {
        // Case when dateTimeInput includes 'T' (ISO 8601 format)
        if (dateTimeInput.includes('T')) {
            [date, time] = dateTimeInput.split('T');
            date = new Date(dateTimeInput);
        } else {
            // Handle cases like 'Thu Aug 22 2024 18:44:49 GMT+0530 (India Standard Time)'
            date = new Date(dateTimeInput);
        }
    } else {
        // If it's not a string, assume it's a Date object
        date = new Date(dateTimeInput);
    }

    // Validate the date object
    if (!date || isNaN(date.getTime())) {
        return '-';
    }

    // Date components
    const month = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
    const dd = String(date.getDate()).padStart(2, '0');
    const mm = String(date.getMonth() + 1).padStart(2, '0');
    const yyyy = date.getFullYear();
    const monthName = month[date.getMonth()];

    // Time components (default to 00:00:00 if not provided)
    let hours = String(date.getHours()).padStart(2, '0');
    let minutes = String(date.getMinutes()).padStart(2, '0');
    let seconds = String(date.getSeconds()).padStart(2, '0');

    // Return formatted date and time based on the specified format
    switch (format) {
        case 'dd-mm-yyyy':
            return `${dd}-${mm}-${yyyy}`;
        case 'yyyy-mm-dd':
            return `${yyyy}-${mm}-${dd}`;
        case 'dd/mm/yyyy':
            return `${dd}/${mm}/${yyyy}`;
        case 'mm/dd/yyyy':
            return `${mm}/${dd}/${yyyy}`;
        case 'month dd, yyyy':
            return `${monthName} ${dd}, ${yyyy}`;
        case 'yyyy-mm-dd, hh:mm:ss':
            return `${yyyy}-${mm}-${dd}, ${hours}:${minutes}:${seconds}`;
        case 'yyyy-mm-dd hh:mm:ss':
            return `${yyyy}-${mm}-${dd} ${hours}:${minutes}:${seconds}`;
        case 'hh:mm:ss':
            return `${hours}:${minutes}:${seconds}`;
        case 'mm-dd-yyyy':
            return `${mm}-${dd}-${yyyy}`;
        case 'month dd, hh:mm':
            return `${monthName} ${dd}, ${hours}:${minutes}`;


        // Add more format cases as needed
        default:
            return '-';
    }
};

export const pageReload = () => {
    setTimeout(() => {
        window.location.reload();
    }, 1000);

}

export const getToken = () => {
    const token = Cookies.get('admin_user_token');
    if (token) {
        return {
            headers: {
                Authorization: `Bearer ${token}`
            }
        };
    } else {
        return null;
    }
};

